// Surgomed — append price to Add to Cart button
document.addEventListener('DOMContentLoaded', function () {
  function updateATCPrice() {
    var btn = document.querySelector('.product-info__add-button button[name="add"]');
    if (!btn) return;

    var priceEl = document.querySelector('.product-info__price .price__current .money, .product-info__price .price-item--regular .money, .product-info__price .price .money');
    if (!priceEl) return;

    var price = priceEl.textContent.trim();
    var baseText = btn.getAttribute('data-add-to-cart-text') || 'Add to cart';

    if (btn.disabled) {
      btn.textContent = btn.textContent;
      return;
    }

    btn.textContent = baseText + ' — ' + price;
  }

  // Run on load
  updateATCPrice();

  // Re-run when variant changes (Shopify dispatches this event)
  document.addEventListener('variant:changed', updateATCPrice);
  document.addEventListener('variantChange', updateATCPrice);

  // Fallback — observe price element for changes
  var priceContainer = document.querySelector('.product-info__price');
  if (priceContainer) {
    var observer = new MutationObserver(updateATCPrice);
    observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }
});
